"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
/**
 * A hook which triggers the provided callback function when the escape key is pressed.
 */
function useHandleEscapeKeyPress(onEscapeKeyDown) {
    (0, react_1.useEffect)(function () {
        var handleEscapeKeyDown = function (event) {
            if (event.code === 'Escape' || event.key === 'Esc') {
                onEscapeKeyDown();
            }
        };
        document.addEventListener('keydown', handleEscapeKeyDown);
        return function () {
            document.removeEventListener('keydown', handleEscapeKeyDown);
        };
    });
}
exports.default = useHandleEscapeKeyPress;
